<template>
    <div class="header-menu-wrapper" v-click-outside="hideChilds">
        <nav
            :class="[
                'header-menu-nav-links',
                { 'is-opened': navIndexOpened !== -1 },
            ]"
            role="navigation"
            aria-label="Main menu"
        >
            <ul class="header-menu-nav-links__list" role="menubar">
                <li
                    :class="[
                        'header-menu-nav-links__list-item',
                        {
                            'header-menu-nav-links__list-item--opened': indexA === navIndexOpened,
                            'is-active': checkActiveState(itemA)
                        }
                    ]"
                    v-for="(itemA, indexA) in data"
                    :key="indexA"
                    role="none"
                >
                    <a
                        :href="getHref(itemA)"
                        :class="[
                            'header-menu-nav-links__item-link u-expand-area',
                            {
                                'header-menu-nav-links__item-link--is-parent': itemA.items && itemA.items.length,
                            }
                        ]"
                        role="menuitem"
                        @click="showChilds($event, indexA, itemA)"
                    >
                        <span
                            class="header-menu-nav-links__link-name"
                            v-html="itemA.name"
                        ></span>
                    </a>
                </li>
            </ul>
        </nav>

        <div class="header-menu">
            <ul class="header-menu__list">
                <li
                    :class="[
                        'header-menu__list-item',
                        {
                            'header-menu__list-item--opened': navIndexOpened === indexA
                        }
                    ]"
                    v-for="(itemA, indexA) in data"
                    :key="indexA"
                >
                    <div class="container" v-if="navIndexOpened === indexA">
                        <div class="header-menu__submenu-wrapper" v-if="itemA.items && itemA.items.length">
                            <div class="header-menu__top">
                                <component
                                    :is="isRedirect(firstObj) ? 'p' : 'a'"
                                    :href="isRedirect(firstObj) ? null : getHref(firstObj)"
                                    class="header-menu__title"
                                    @click="handleFirstObjClick(firstObj)"
                                >
                                    <span v-html="firstObj.name"></span>
                                    <div class="header-menu__arrow-icon" v-if="!isRedirect(firstObj)">
                                        <z-icon
                                            name="arrows/caret-light"
                                            width="16"
                                            height="16"
                                            dir="right"
                                        />
                                    </div>
                                </component>
                                <button type="button" class="header-menu__button" @click="hideChilds">
                                    <z-icon
                                        name="tools/close"
                                        width="24"
                                        height="24"
                                        class="header-menu__button-icon"
                                    ></z-icon>
                                </button>
                            </div>

                            <div class="header-menu__row">
                                <transition
                                    @enter="animationEnter"
                                    @leave="animationLeave"
                                >
                                    <div class="header-menu__col" v-if="firstObj">
                                        <ul class="header-menu-item" role="menu">
                                            <template v-for="(itemB, indexB) in itemA.items" :key="indexB">
                                                <li
                                                    class="header-menu-item__list-item"
                                                    :class="{
                                                        'is-parent': itemB.items && itemB.items.length,
                                                        'is-active': itemB.active,
                                                        'is-opened': secondObj !== null && secondObj.link === itemB.link && secondObj.name === itemB.name
                                                    }"
                                                    role="none"
                                                >
                                                    <a
                                                        :href="getHref(itemB)"
                                                        @click="showSecondLvl($event, itemB, '2')"
                                                        class="header-menu-item__item-link"
                                                        role="menuitem"
                                                        :aria-label="itemB.name"
                                                        :target="itemB.params && itemB.params.TARGET ? itemB.params.TARGET : '_self'"
                                                    >
                                                        <span class="header-menu-item__item-link-name" v-html="itemB.name"></span>
                                                        <span v-if="itemB.items && itemB.items.length" class="header-menu-item__item-link-arrow">
                                                            <z-icon
                                                                name="arrows/caret-light"
                                                                width="16"
                                                                height="16"
                                                                dir="right"
                                                            />
                                                        </span>
                                                    </a>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </transition>
                                <transition
                                    @enter="animationEnter"
                                    @leave="animationLeave"
                                >
                                    <div
                                        class="header-menu__col"
                                        v-if="secondObj"
                                    >
                                        <component
                                            :is="isRedirect(secondObj) ? 'p' : 'a'"
                                            :href="isRedirect(secondObj) ? false : getHref(secondObj)"
                                            class="header-menu__title header-menu__title--submenu"
                                        >
                                            <span v-html="secondObj.name"></span>
                                            <div class="header-menu__arrow-icon" v-if="!isRedirect(secondObj)">
                                                <z-icon
                                                    name="arrows/caret-light"
                                                    width="12"
                                                    height="12"
                                                    dir="right"
                                                />
                                            </div>
                                        </component>
                                        <ul
                                            class="header-submenu header-submenu--second"
                                            v-if="secondObj &&
                                                secondObj.items &&
                                                secondObj.items.length
                                            "
                                            role="menu"
                                        >
                                            <template
                                                v-for="(itemC, indexC) in secondObj.items" :key="indexC"
                                            >
                                                <li
                                                    class="header-menu-item__list-item"
                                                    :class="{
                                                        'is-parent': itemC.items && itemC.items.length,
                                                        'is-active': itemC.active,
                                                        'is-opened': thirdObj !== null && thirdObj.link === itemC.link && thirdObj.name === itemC.name
                                                    }"
                                                    role="none"
                                                >
                                                    <a
                                                        :href="getHref(itemC)"
                                                        @click="showThirdLvl($event, itemC, '3')"
                                                        class="header-submenu__item-link"
                                                        :target="itemC.params && itemC.params.TARGET ? itemC.params.TARGET : '_self'"
                                                        role="menuitem"
                                                        :aria-label="itemC.name"
                                                    >
                                                        <span class="header-menu-item__item-link-name" v-html="itemC.name"></span>
                                                        <span v-if="itemC.items && itemC.items.length" class="header-menu-item__item-link-arrow">
                                                            <z-icon
                                                                name="arrows/caret-light"
                                                                width="16"
                                                                height="16"
                                                                dir="right"
                                                            />
                                                        </span>
                                                    </a>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </transition>
                                <transition
                                    @enter="animationEnter"
                                    @leave="animationLeave"
                                >
                                    <div class="header-menu__col" v-if="secondObj && thirdObj && thirdObj.items && thirdObj.items.length">
                                        <component
                                            :is="isRedirect(thirdObj) ? 'p' : 'a'"
                                            :href="isRedirect(thirdObj) ? false : getHref(thirdObj)"
                                            class="header-menu__title header-menu__title--submenu"
                                        >
                                            <span v-html="thirdObj.name"></span>
                                            <div class="header-menu__arrow-icon" v-if="!isRedirect(thirdObj)">
                                                <z-icon
                                                    name="arrows/caret-light"
                                                    width="12"
                                                    height="12"
                                                    dir="right"
                                                />
                                            </div>
                                        </component>
                                        <ul class="header-submenu header-submenu--third" role="menu">
                                            <li
                                                v-for="(itemD, indexD) in thirdObj.items"
                                                :key="indexD"
                                                :class="{
                                                    'is-active': itemD.active,
                                                }"
                                                class="header-submenu__item"
                                                role="none"
                                            >
                                                <a
                                                    :href="getHref(itemD)"
                                                    class="header-submenu__item-link"
                                                    :target="itemD.params && itemD.params.TARGET ? itemD.params.TARGET : '_self'"
                                                    role="menuitem"
                                                    :aria-label="itemD.name"
                                                >
                                                    <span
                                                        class="header-submenu__link-text"
                                                        v-html="itemD.name"
                                                    ></span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui.js'
import { mixinDevice } from '@/utils/mixin'

export default {
    name: 'navigation-main',
    emits: ['menuToggle'],
    mixins: [mixinDevice],
    data () {
        return {
            data: this.$root.app.components.navigation.top,
            hovered: null,
            subMenu: false,
            subMenuItems: [],
            navIndexOpened: -1,
            firstObj: null,
            secondObj: null,
            thirdObj: null,
            lang: window.App.page.lang,
        }
    },
    watch: {
        device (newVal) {
            const isSmallScreen = ['tablet', 'v-tablet', 'mobile'].includes(newVal)

            if (isSmallScreen && this.navIndexOpened !== -1) {
                this.hideChilds()
            }
        }
    },
    methods: {
        animationEnter (el) {
            Velocity(el, 'transition.slideLeftBigIn', { duration: 300 })
        },
        animationLeave (el) {
            Velocity(el, 'transition.slideRightBigOut', { duration: 300 })
        },
        showSecondLvl (event, item) {
            this.secondObj = null
            this.thirdObj = null
            if (item.items?.length) {
                event.preventDefault()
                this.secondObj = item
            }
        },
        showThirdLvl (event, item) {
            this.thirdObj = null
            if (item.items?.length) {
                event.preventDefault()
                this.thirdObj = item
            }
        },
        showChilds (event, i, item) {
            this.firstObj = item
            this.secondObj = null
            this.thirdObj = null
            if (item.hasOwnProperty('items') && item.items.length) {
                event.preventDefault()
                this.navIndexOpened === i
                    ? this.hideChilds()
                    : (this.navIndexOpened = i)

                this.$emit('menuToggle', this.navIndexOpened !== -1)
            } else {
                this.hideChilds()
            }
        },
        hideChilds () {
            this.firstObj = null
            this.secondObj = null
            this.thirdObj = null
            this.navIndexOpened = -1
            this.$emit('menuToggle', this.navIndexOpened !== -1)
        },
        getHref (item) {
            if (Array.isArray(item.pageParams)) {
                return item.link
            }

            if (item.pageParams?.redirect) {
                return item.pageParams?.redirect
            } else {
                return item.link
            }
        },
        isRedirect (item) {
            if (Array.isArray(item.pageParams)) {
                return false
            }

            if (item.pageParams?.redirect) {
                return true
            } else {
                return false
            }
        },
        checkActiveState (item) {
            if (item.active === true) return true

            for (let i = 0; i < item.items?.length; i++) {
                if (item.items[i].active === true) return true
            }

            return false
        },

        handleFirstObjClick(item){
            if(this.isRedirect(item)) return

            switch (item.link){
            case '/about/':
                ym(98161189,'reachGoal',`${this.lang}-menu-sabindex-about`);
                break;
            case '/sustainability/':
                ym(98161189,'reachGoal',`${this.lang}-menu-sabindex-sustainability`)
                break;
            default:
                break
            }
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
